import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}
export function loginIndex(params) {
  return request({
    url: '/login',
    method: 'post',
    data:params
  })
}

// export function login(data = {}) {
//   return request({
//     url: '/admin/login',
//     method: 'post',
//     data
//   });
// };

// export function getInfo() {
//   return request({
//     url: '/admin/info',
//     method: 'get',
//   })
// }

export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js